<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('expenseItem.expenseCode') }}</label>
            <input
              v-model="model.exp_code"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('exp_code') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('exp_code')"
            >{{ errors.first('exp_code') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('expenseItem.expenseItemCategory') }}</label>
            <a-select
              v-model.number="model.exp_cat_id"
              :options="category_options"
              class="ts-w-full"
            ></a-select>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('exp_cat_id')"
            >{{ errors.first('exp_cat_id') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('expenseItem.expenseItem') }}</label>
            <input
              v-model="model.exp_item"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('exp_item') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('exp_item')"
            >{{ errors.first('exp_item') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('expenseItem.expenseDescription') }}</label>
            <textarea
              v-model="model.exp_desc" 
              rows="3" 
              class="form-control"
            ></textarea>
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('exp_desc')"
            >{{ errors.first('exp_desc') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{
              $t('cancel')
              }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
            >{{ $t('save') }}</ts-button>
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onUpdate"
              :waiting="waiting"
            >{{ $t('update') }}</ts-button>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'expenseItem',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      category_options: [],
      employee_options: [],
      model: {
        exp_id: 0,
        exp_cat_id: null,
        exp_code: null,
        exp_item: null,
        exp_desc: null
      }
    }
  },
  async created() {
    await this.fetchCategory()
    await this.setEditData()
  },
  computed: {
    ...mapState('expense/expenseItem', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('expense/expenseItem/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('expense/expenseItem/update', {
          id: this.model.exp_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.exp_id = this.edit_data.exp_id
        this.model.exp_cat_id = this.edit_data.exp_cat_id
        this.model.exp_code = this.edit_data.exp_code
        this.model.exp_item = this.edit_data.exp_item
        this.model.exp_desc = this.edit_data.exp_desc
      }
    },
    async fetchCategory(){
      this.loading = true
      await this.$store.dispatch('expense/expenseItem/getCategory')
        .then(response => {
          this.category_options =  response.data.map(el => ({
            value: el.exp_cat_id,
            label: el.exp_category
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
